import live_logo_1 from "../images/heart-icon-01.png";
import live_logo_2 from "../images/heart-icon-02.png";
import live_logo_3 from "../images/heart-icon-03.png";
import live_logo_4 from "../images/heart-icon-04.png";
import live_logo_5 from "../images/heart-icon-05.png";
import live_logo_6 from "../images/heart-icon-06.png";
import live_logo_7 from "../images/heart-icon-07.png";
import BubbleHearts from "./canvas-heart";
const Heart = () => {
  const assets = [
    live_logo_1,
    live_logo_2,
    live_logo_3,
    live_logo_4,
    live_logo_5,
    live_logo_6,
    live_logo_7
  ];
  assets.forEach((src: string, index: number) => {
    assets[index] = new Promise(resolve => {
      const img: HTMLImageElement = new Image();
      img.onload = resolve.bind(null, img);
      img.src = src;
    });
  });
  // Images preload
  Promise.all(assets).then((images: HTMLImageElement[]) => {
    const random = {
      uniform: (min: number, max: number) => {
        return min + (max - min) * Math.random();
      },
      uniformDiscrete: (i: number, j: number) => {
        return i + Math.floor((j - i + 1) * random.uniform(0, 1));
      }
    };
    // Init stage
    const stage = new BubbleHearts();
    const canvas = stage.canvas;
    const chatExtendHeart = document.querySelector(".chat__extend--heart") as HTMLElement;
    const heartCanvas = document.querySelector("#heart__canvas") as HTMLElement;

    canvas.width = 200;
    canvas.height = 400;
    canvas.style.width = "100px";
    canvas.style.height = "200px";
    chatExtendHeart.appendChild(canvas);
    heartCanvas.addEventListener(
      "click",
      () => {
        stage.bubble(images[random.uniformDiscrete(0, images.length - 1)]);
      },
      false
    );
  });
};

export default Heart;



// WEBPACK FOOTER //
// ./src/publics/assets/js/canvas-heart-init.ts